{
  "helpMessage": "<h3>कोई सवाल है?</h3>\n<p>हमारी टीम मदद के लिए तैयार है - कॉल करें:<br/>\n<a><strong>☎️ {{phone}}</strong></a> (फिर <strong>विकल्प 2</strong> दबाएँ)<br/>\nसोमवार से शुक्रवार, सुबह 8 से शाम 5 बजे तक।</p>",
  "text": "<p>हम आपके रेफर करने वाले डॉक्टर को सूचित कर देंगे, और वे आपसे अगले कदमों पर चर्चा करने के लिए संपर्क कर सकते हैं।</p>\n<p>अभी के लिए आपको और कुछ करने की ज़रूरत नहीं है।</p>",
  "title": "आपने अभी बुक न करने का विकल्प चुना है।"
}
